export async function downloadAndSetFileUrls(damageReport: any) {
  if (damageReport?.causesOfDamage) {
    for (const cause of damageReport.causesOfDamage) {
      if (cause?.damageDetailPicture?.id) {
        const fileId = cause.damageDetailPicture.id
        cause.damageDetailPicture = await setExistingFiles(fileId)
      }
      if (cause?.damageRoomViewPicture?.id) {
        const fileId = cause.damageRoomViewPicture.id
        cause.damageRoomViewPicture = await setExistingFiles(fileId)
      }
      if (cause?.causeOfDamageVideo?.id) {
        const fileId = cause.causeOfDamageVideo.id
        cause.causeOfDamageVideo = await setExistingFiles(fileId)
      }
    }
  }

  if (damageReport?.exteriorView) {
    for (const image of damageReport.exteriorView.images) {
      if (image?.id) {
        const fileId = image.id
        const result = await setExistingFiles(fileId)
        image.id = result.id
        image.url = result.url
      }
    }
  }

  if (damageReport?.measurementProtocol?.measurementMethods) {
    const measurementMethods = damageReport.measurementProtocol
      .measurementMethods as MeasurementMethods
    for (const key of Object.keys(measurementMethods)) {
      const fields = measurementMethods[key as keyof MeasurementMethods]?.fields
      if (fields) {
        for (const field of fields) {
          if (field?.images?.length) {
            for (const image of field.images) {
              if (image?.id) {
                const fileId = image.id
                field.images = { ...field.images, ...(await setExistingFiles(fileId)) } as any
              }
            }
          }
        }
      }
    }
  }

  if (damageReport?.additionalServices) {
    const additionalServices = damageReport.additionalServices as AdditionalServices
    for (const key of Object.keys(additionalServices)) {
      const fields = (additionalServices[key as keyof AdditionalServices] as any)?.fields
      if (fields) {
        for (const field of fields) {
          if (field?.image?.id) {
            const fileId = field.image.id
            field.image = { ...field.image, ...(await setExistingFiles(fileId)) }
          }
        }
      }
    }
  }

  if (damageReport?.serviceSetup) {
    if (damageReport?.serviceSetup?.signature?.id) {
      const fileId = damageReport.serviceSetup.signature.id
      damageReport.serviceSetup.signature = {
        ...damageReport.serviceSetup.signature,
        ...(await setExistingFiles(fileId))
      }
    }
  }

  if (damageReport?.declarationOfAssignment?.signature?.id) {
    const fileId = damageReport.declarationOfAssignment.signature.id
    const result = await setExistingFiles(fileId)
    damageReport.declarationOfAssignment.signature = result
    damageReport.declarationOfAssignment.signatureDataUrl = result.url
  }

  if (damageReport?.signedServices?.signature?.id) {
    const fileId = damageReport.signedServices.signature.id
    const result = await setExistingFiles(fileId)
    damageReport.signedServices.signature = result
    damageReport.signedServices.signatureDataUrl = result.url
  }

  if (damageReport?.orderConfirmation?.signature?.id) {
    const fileId = damageReport.orderConfirmation.signature.id
    const result = await setExistingFiles(fileId)
    damageReport.orderConfirmation.signature = result
    damageReport.orderConfirmation.signatureDataUrl = result.url
  }

  if (damageReport?.rssSignature?.signature?.id) {
    const fileId = damageReport.rssSignature.signature.id
    const result = await setExistingFiles(fileId)
    damageReport.rssSignature.signature = result
    damageReport.rssSignature.signatureDataUrl = result.url
  }

  if (damageReport?.damageReportPdf?.id) {
    const fileId = damageReport.damageReportPdf.id
    damageReport.damageReportPdf = await setExistingFiles(fileId)
  }
}
